module.exports = __webpack_public_path__ + "img/brushes-left_jp.ec73a01.jpg";